import React from "react";

import { Box, Typography } from "@mui/material";

const VariabilityDisplay = ({ value }) => {
  return (
    <Box>
      {value ? (
        <Box></Box>
      ) : (
        <Typography sx={{ fontSize: "10px" }}>not set...</Typography>
      )}
    </Box>
  );
};

export default VariabilityDisplay;
